import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ISourceCode, SourceCode, SourceCodePropertyValues } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/SourceCode";
import { NAMESPACE } from "./_Namespace";

//interface IGetAnnotationsEventData
//{
//    callback: Function;
//    editor: any;
//    options: any;
//    text: string;
//}

//async function cSharpRuntimeSourceCodeProcessPathAsync(completionContext: CompletionContext): Promise<Nullable<CompletionResult>>
//{
//    const
//        element = completionContext.view?.dom;

//    if (!element)
//        return null;

//    const
//        owner = $$(element).closest(".rad-control-input-control").radControl() as IInputControl | undefined;

//    if (!owner)
//        return null;

//    const
//        page = owner.page.get();

//    Assert.isInstanceOf(ClassPropertyDialog, page, "page");

//    const
//        processPath = page?.instance ? page.instance : null,
//        dataSource = owner.dataSource.get(),
//        data = dataSource ? dataSource.data.get() : null,
//        dataSourceProperty = owner.dataSourceProperty.get();

//    if (!(processPath instanceof ProcessPath))
//        return null;

//    const
//        processDesigner = processPath.processDesigner.get(),
//        processVersionData = processDesigner ? processDesigner._getProcessVersionData() : null;

//    if (!processVersionData)
//        return null;

//    const
//        processPathId = processPath.id.get();

//    if (!processPathId)
//        return null;

//    const
//        processPathData =
//            ArrayHelper.firstOrDefault(
//                processVersionData.processPaths,
//                item => item.id === processPathId
//            );

//    if (!processPathData)
//        return null;

//    processPathData.condition =
//        data?.condition
//            ? data.condition
//            : null;

//    const
//        propertyName =
//            dataSourceProperty
//                ? StringHelper.toUpperCamelCase(dataSourceProperty)
//                : null;

//    if (!propertyName)
//        return null;

//    const
//        result = await (
//          ServiceManager.getRequired(WebApiClientService)
//              .createApiMethodRequest(
//                  "DataService",
//                  "CallDataService",
//                  {
//                      id: "B185975F-0E14-4944-B706-6353F0D67DC4",
//                      operation: "HintSourceCodeProcessPath",
//                      data: ObjectHelper.toJson({
//                          processVersionData: processVersionData,
//                          processPathId: processPathId,
//                          propertyName: propertyName,
//                          position: completionContext.pos
//                      })
//                  },
//                  null,
//                  false
//              )
//              .executeAsync()
//      );

//    if (!result?.hint)
//        return null;

//    return {
//        from: result.hint.from,
//        to: result.hint.to,
//        options:
//            Array.isArray(result.hint.options)
//                ? (result.hint.options as ISourceCodeHintOption[])
//                    .map(item =>
//                    {
//                        return {
//                            label: item.value,
//                            displayLabel: item.description,
//                        }
//                    })
//                : []
//    };
//}

export type RuntimeSourceCodeProcessPropertyValues =
    SourceCodePropertyValues
    & {
    };

export type RuntimeSourceCodeProcessProperties = {
    [name in keyof RuntimeSourceCodeProcessPropertyValues]: Property<RuntimeSourceCodeProcessPropertyValues[name]>
};

export interface IRuntimeSourceCodeProcess extends ISourceCode, RuntimeSourceCodeProcessProperties
{
}

export class RuntimeSourceCodeProcess extends SourceCode implements IRuntimeSourceCodeProcess
{
    // #region Static

    public static override classNamespace = NAMESPACE + "RuntimeSourceCodeProcess";
    public static override className = "RuntimeSourceCodeProcess";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<RuntimeSourceCodeProcessPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<RuntimeSourceCodeProcessPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    //protected override _bindEvents()
    //{
    //    super._bindEvents();

    //    Assert.isNotNullOrUndefined(this.editor, "this.editor");

    //    this.editor.on("keyup", (editor: any, event: any) => { this.onEditorKeyUp(new DummyEvent(this), { editor: editor, event: event }); });
    //}
    //protected override _createElement()
    //{
    //    const
    //        $$element = super._createElement();

    //    Assert.isNotNullOrUndefined(radWindow.CodeMirror, "radWindow.CodeMirror");
    //    Assert.isNotNullOrUndefined(this.editor, "this.editor");

    //    const
    //        mac = radWindow.CodeMirror.keyMap.default === radWindow.CodeMirror.keyMap.macDefault,
    //        map: { [name: string]: string } = {};

    //    map[(mac ? "Cmd" : "Ctrl") + "-Space"] = "autoCompleteRuntimeSourceCodeProcessPath";

    //    this.editor.addKeyMap(map);
    //    this.editor
    //        .setOption(
    //            "lint",
    //            {
    //                getAnnotations: (text: string, callback: Function, options: any, editor: any) =>
    //                {
    //                    this.onEditorGetAnnotations(new DummyEvent(this), {
    //                        callback: callback,
    //                        editor: editor,
    //                        options: options,
    //                        text: text
    //                    });
    //                },
    //                async: true
    //            }
    //    );

    //    return $$element;
    //}
    protected override _createElementComplete()
    {
        super._createElementComplete();

        this.addCssClass("rad-control-runtime-source-code-process");
    }

    // #endregion

    // #region Event Handlers

    //protected onEditorGetAnnotations(evt: IJNativeEvent, eventData: IGetAnnotationsEventData)
    //{
    //    if (!eventData.text)
    //    {
    //        eventData.callback([]);
    //        return;
    //    }

    //    const
    //        self = evt.data.self as this,
    //        owner = self.editor?.options?._owner || null;

    //    Assert.isInstanceOf(RuntimeSourceCodeProcess, owner, "owner");
    //    Assert.isNotNullOrUndefined(self.editor, "self.editor");

    //    const
    //        page = owner.page.get();

    //    Assert.isInstanceOf(ClassPropertyDialog, page, "page");

    //    //var
    //    //    processPath = page?.instance ? page.instance : null,
    //    //    dataSource = owner.dataSource.get(),
    //    //    data = dataSource ? dataSource.data.get() : null,
    //    //    dataSourceProperty = owner.dataSourceProperty.get(),
    //    //    processPathId = null,
    //    //    propertyName = null,
    //    //    processDesigner = null,
    //    //    processVersionData = null,
    //    //    processPathData = null;

    //    //if (!(processPath instanceof namespace.ProcessDesigner.ProcessPath))
    //    //    return;

    //    //processDesigner = processPath.processDesignerGet();
    //    //processVersionData = processDesigner ? processDesigner._getProcessVersionData() : null;

    //    //if (!processVersionData)
    //    //    return;

    //    //processPathId = processPath.idGet();

    //    //if (!processPathId)
    //    //    return;

    //    //processPathData =
    //    //    processVersionData
    //    //        .processPaths.firstOrDefault(item => item.id === processPathId);

    //    //if (!processPathData)
    //    //    return;

    //    //processPathData.condition =
    //    //    data?.condition
    //    //        ? data.condition
    //    //        : null;

    //    //propertyName =
    //    //    dataSourceProperty
    //    //        ? dataSourceProperty.toUpperCamelCase()
    //    //        : null;

    //    //if (!propertyName)
    //    //    return;

    //    //WebApiClient.instance
    //    //    .createApiMethodRequest(
    //    //        "DataService",
    //    //        "CallDataService",
    //    //        {
    //    //            id: "B185975F-0E14-4944-B706-6353F0D67DC4",
    //    //            operation: "LintSourceCodeProcessPath",
    //    //            data: ObjectHelper.toJson({
    //    //                processVersionData: processVersionData,
    //    //                processPathId: processPathId,
    //    //                propertyName: propertyName
    //    //            })
    //    //        },
    //    //        null,
    //    //        false
    //    //    )
    //    //    .executeAsync()
    //    //    .then(result =>
    //    //    {
    //    //        if (result?.lint && Array.isArray(result.lint.annotations))
    //    //        {
    //    //            eventData.callback(
    //    //                result.lint.annotations
    //    //                    .select(item =>
    //    //                    {
    //    //                        return {
    //    //                            severity: item.severity.toLowerCase(),
    //    //                            message: item.message,
    //    //                            from:
    //    //                                CodeMirror.Pos(
    //    //                                    item.start.line,
    //    //                                    item.start.character
    //    //                                ),
    //    //                            to:
    //    //                                CodeMirror.Pos(
    //    //                                    item.end.line,
    //    //                                    item.end.character
    //    //                                )
    //    //                        };
    //    //                    })
    //    //            );
    //    //        }
    //    //    });
    //}
    //protected onEditorKeyUp(evt: IJNativeEvent, eventData: { editor: any, event: KeyboardEvent })
    //{
    //    const
    //        self = evt.data.self as this;

    //    Assert.isNotNullOrUndefined(radWindow.CodeMirror, "radWindow.CodeMirror");
    //    Assert.isNotNullOrUndefined(self.editor, "self.editor");

    //    //"ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890_."
    //    if (self.editor.state.completionActive && ".".indexOf(eventData.event.key) === -1)
    //        radWindow.CodeMirror.commands.autoCompleteRuntimeSourceCodeProcessPath(self.editor, null, { completeSingle: false });
    //}

    // #endregion

    // #endregion
}

